var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgThumbsDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3 3h1.75A1.25 1.25 0 0 1 6 4.25v9.5A1.25 1.25 0 0 1 4.75 15H3V3Zm10.5 12h3.91a3 3 0 0 0 2.95-3.54l-.91-5A3 3 0 0 0 16.5 4H7v9l2.93 4.88a.48.48 0 0 1 .07.26V21h.5a2.5 2.5 0 0 0 2.5-2.5v-3a.5.5 0 0 1 .5-.5Z"
})));
export default SvgThumbsDown;